<template>
  <div class="content" :class="fullWidth ? 'full-width' : ''">
    <head-title class="title" :title="title" v-if="title" />
    <div class="description card-description" v-if="description">
      <div class="card-image" v-if="image.src">
        <img :src="image.src" :alt="image.alt" />
      </div>
      <div class="wrap-description">
        <div class="card-information">
          <div class="card-pretitle" v-if="description.cardType">
            <span>{{ description.cardType }}</span>
          </div>
          <head-title
            class="card-name"
            :title="description.cardName"
            v-if="description.cardName"
          />
          <head-title
            class="card-name card-title"
            :title="title"
            v-if="title && fullWidth"
          />
          <div class="card-details" v-if="description.cardDetails">
            <ul>
              <li
                v-for="(detail, key) in description.cardDetails"
                :key="key"
                v-safe-html="detail.label"
              />
            </ul>
          </div>
        </div>
        <div class="card-mantein">
          <div class="card-cost" v-if="description.cardCost">
            <p>{{ description.cardCost }}</p>
          </div>
          <div class="card-limitations" v-if="description.cardMaintenance">
            <p>{{ description.cardMaintenance }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="action-button" v-if="button">
      <sales-button
        class="sales-button"
        color="#001391"
        width="100%"
        borderRadius="8px"
        :label="button.label"
        @click.native="button.action"
      />
    </div>
  </div>
</template>
<script>
import SalesButton from "@/components/core/SalesButton";
import HeadTitle from "@/components/core/HeadTitle";

export default {
  name: "OfferPanel",
  components: {
    SalesButton,
    HeadTitle
  },
  props: {
    fullWidth: Boolean,
    title: String,
    description: Object,
    button: Object
  },
  computed: {
    image() {
      if (!this.description) return {};
      return this.description.cardImage;
    }
  }
};
</script>
<style scoped>
.content {
  background-color: #f7f8f8;
  padding: 20px 16px;
  border-radius: 16px;
}
.title {
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 16px;
}
.description {
  padding: 16px 0;
  border-radius: 16px;
  color: #070e46;
}
img {
  width: auto;
  height: auto;
  max-height: 220px;
  max-width: 100%;
}
.card-image {
  width: 30%;
  margin-bottom: 16px;
}
.card-pretitle {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}
.card-title {
  display: none;
}
.card-name {
  font-size: 1.5rem;
  line-height: 2rem;
  margin: 8px 0 16px;
}
.card-details ul {
  white-space: normal;
  padding: 0;
  padding-left: 20px;
  margin: 20px 0;
  list-style: none;
}
.card-details li {
  font-size: 1rem;
  margin-bottom: 20px;
  line-height: 1.5rem;
  position: relative;
  padding-left: 30px;
}
.card-details li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  width: 13px;
  height: 7px;
  border-radius: 50px;
  background-color: #070e46;
}
.card-details ::v-deep strong {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-weight: 500;
}
.card-mantein {
  text-align: center;
  margin-top: 34px;
}
.card-mantein p {
  margin: 10px 0;
}
.card-cost {
  font-size: 1.25rem;
}
.card-cost p {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
@media screen and (min-width: 600px) {
  .content {
    padding: 48px 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .title {
    font-size: 2.125rem;
    line-height: 3rem;
    margin-bottom: 40px;
  }
  .description {
    background-color: #fff;
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .card-image {
    width: 100%;
    margin: 15px auto 35px;
    text-align: center;
  }
  .card-name {
    font-size: 1.625rem;
    line-height: 2rem;
    margin: 10px 0 16px;
  }
  .card-information {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .wrap-description {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .card-details {
    flex-grow: 1;
  }
  .card-details ul {
    padding-left: 5px;
    margin: 10px 0;
  }
  .action-button {
    display: none;
  }
  .full-width.content {
    padding: 20px;
  }
  .full-width .description {
    background-color: transparent;
    flex-direction: row;
  }
  .full-width .title {
    display: none;
  }
  .full-width .card-name {
    display: none;
  }
  .full-width .card-title {
    display: block;
  }
  .full-width .card-image {
    width: 30%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  .full-width .wrap-description {
    width: 70%;
    padding: 15px 20px;
  }
  .full-width .card-information {
    margin-top: 25px;
  }
}
@media screen and (min-width: 980px) {
  .full-width .card-mantein {
    max-width: 50%;
  }
}
</style>
